"use strict";
export function init(app, reactHistory = null) {
  window.addEventListener("popstate", () => {
    app.ports.onUrlChange.send(location.href);
  });
  if (reactHistory) {
    reactHistory.listen((_location) => {
      app.ports.onUrlChange.send(window.location.href);
    });
  }
  app.ports.pushUrl.subscribe((newUrl) => {
    window.history.pushState({}, "", newUrl);
    app.ports.onUrlChange.send(location.href);
  });
  app.ports.replaceUrl.subscribe((newUrl) => {
    window.history.replaceState({}, "", newUrl);
    app.ports.onUrlChange.send(location.href);
  });
  if (app.ports.back) {
    app.ports.back.subscribe((n) => {
      window.history.go(-n);
    });
  } else {
    console.info("Elm port 'back' is unused");
  }
}
